export default "__VITE_ASSET__CfeseAYK__"